import {
  setMetaDescription,
  setTitle,
  setMetaTitle,
  setMetaPropertyTag,
} from '../../../global/data/meta.js'

export function setMeta(fund, customTitle) {
  if (fund) {
    const { fundHeader, searchEngine } = fund

    if (fundHeader) {
      const { fundName, indexName, symbol } = fundHeader
      const name = fundName || indexName

      const title =
        (symbol ? symbol + ' | ' : '') +
        (customTitle ? customTitle + ' | ' : '') +
        name

      setTitle(title)
      setMetaTitle(title)
      setMetaDescription(searchEngine)
    }

    setMetaPropertyTag('internalSearch', getInternalSearch(fund))
    setMetaPropertyTag('og:url', window.location.href)
  }
}
/** 
  Custom meta tag for IBM Watson internal search.
  EXAMPLE: product>Mutual Fund; Columbia Dividend Income Fund; GSFTX; IG5, IG1; Institutional;
*/
function getInternalSearch(fund) {
  const { fundHeader } = fund

  //type
  let internalSearchContent = 'product>'

  //fund group
  internalSearchContent += fund.productType + '; '

  //name
  internalSearchContent += fundHeader.fundName + '; '

  //ticker symbol
  if (fundHeader.symbol) {
    internalSearchContent += fundHeader.symbol
    internalSearchContent += '; '
  }

  //investor goals
  if (fundHeader.investorGoals) {
    const investorGoalFilters = fundHeader.investorGoals.value
    if (investorGoalFilters) {
      for (const investorGoalFilter of investorGoalFilters) {
        internalSearchContent += investorGoalFilter.code + ', '
      }
      //trim off last comma
      internalSearchContent = internalSearchContent.slice(0, -2)
    }
    internalSearchContent += '; '
  }

  //fund class
  if (fundHeader.fundClass) {
    internalSearchContent += fundHeader.fundClass
    internalSearchContent += '; '
  }
  return internalSearchContent
}
